<template>
  <div class="overlay-wrapper" :class="{ zoomed: zoomed }">
    <div class="overlay-bg" @click="toggleZoom"></div>
    <div class="overlay-area" :style="areaStyle"></div>
    <div class="overlay-inner">
      <div
        ref="image"
        class="mp-print-image overlay-image"
        :data-product="productType"
        :data-color="productColor"
        @click="toggleZoom"
      >
        <img :src="front" class="mp-print-image__printing" alt="" />
      </div>
      <i
        class="zoom-icon"
        :class="{ 'icon-zoom-in': !zoomed, 'icon-zoom-out': zoomed }"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageOverlayZoom',

  props: {
    skuNo: { type: String, required: true },
    front: { type: String, required: true } // 前面画像URL
  },

  data() {
    return {
      zoomed: false,
      areaRect: {}
    };
  },

  watch: {
    zoomed(bool) {
      document.querySelector('html').classList.toggle('is-fixed', bool);
    }
  },

  computed: {
    areaStyle() {
      return {
        width: this.areaRect.width,
        height: this.areaRect.height
      };
    },

    productType() {
      return this.skuNo.split('-')[0];
    },

    productColor() {
      return this.skuNo.split('-')[1];
    }
  },

  mounted() {
    const rect = this.$refs.image.getBoundingClientRect();
    this.areaRect = {
      width: `${rect.width}px`,
      height: `${rect.height}px`
    };
  },

  methods: {
    toggleZoom() {
      if (!this.zoomed) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },

    zoomIn() {
      // 既に拡大中の場合は計算しない
      if (this.zoomed) {
        return;
      }

      this.zoomed = true;
    },

    zoomOut() {
      this.zoomed = false;
    }
  }
};
</script>

<style>
html.is-fixed,
html.is-fixed body {
  height: 100%;
  overflow: hidden;
}
html.is-fixed .p-global-header-wrapper,
html.is-fixed .p-global-header {
  z-index: 0;
}
</style>
<style scoped>
@import '@built-css/shop/mangaplusgoods/printimage.css';

.overlay-wrapper {
  position: relative;
  /*display: inline-block;*/
  z-index: auto;
}
.overlay-wrapper.zoomed {
  z-index: 999;
}
.overlay-inner {
  position: relative;
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  translate: 0 0;
  /*transition: translate 0.3s linear;*/
}
.overlay-area {
  display: none;
  z-index: 0;
}
.overlay-wrapper.zoomed .overlay-area {
  display: block;
}
.overlay-wrapper.zoomed .overlay-inner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-width: 720px;
  max-height: 50vh;
  translate: 0 50%;
}
.overlay-image {
  cursor: zoom-in;
  z-index: auto;
}
.overlay-wrapper.zoomed .overlay-image {
  z-index: 1;
}
@media (min-width: 768px) {
  .overlay-wrapper.zoomed .overlay-inner {
    translate: 50% 50%;
  }
}

.overlay-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #222;
  opacity: 0;
  transition: ease 0.28s;
  pointer-events: none;
  z-index: -1;
}
.overlay-wrapper.zoomed .overlay-bg {
  opacity: 0.24;
  pointer-events: auto;
}
.zoom-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #888;
  transition: ease 0.28s;
  z-index: 2;
}
.overlay-wrapper.zoomed .zoom-icon {
  color: #202020;
  right: 10px;
  font-size: 2em;
}
</style>
